import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import * as bootstrap from "bootstrap";
import Pagination from "../../../../components/private/pagination";

const Entity = () => {
  const { token, authFetch } = useContext(AuthContext);

  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);

  // FILTROS
  const [search, setSearch] = useState("");
  const [stateFilter, setStateFilter] = useState("all");

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // MODAL CREAR
  let modalInstance = null;

  const [formData, setFormData] = useState({
    name: "",
    nit: ""
  });

  // MODAL CAMBIAR ESTADO
  const [showModal, setShowModal] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);

  // =====================================================
  // CARGAR ENTIDADES
  // =====================================================

  useEffect(() => {
    if (!token) return;

    const loadEntities = async () => {
      setLoading(true);

      try {
        const data = await authFetch(ENDPOINTS.getEntity);

        if (data.success && data.entidades) {
          setEntities(data.entidades);
        } else {
          setEntities([]);
        }

      } catch (error) {
        console.error("Error cargando entidades:", error);
        setEntities([]);
      }

      setLoading(false);
    };

    loadEntities();
  }, [token, authFetch]);

  // =====================================================
  // FILTRO
  // =====================================================

  const filteredEntities = (entities || []).filter((entity) => {

    const query = search.toLowerCase();

    const matchesSearch =
      entity.name?.toLowerCase().includes(query) ||
      entity.nit?.toLowerCase().includes(query);

    const matchesState =
      stateFilter === "all" || String(entity.state) === stateFilter;

    return matchesSearch && matchesState;
  });

  // =====================================================
  // PAGINACIÓN
  // =====================================================

  const totalPages = Math.ceil(filteredEntities.length / recordsPerPage);

  const currentEntities = filteredEntities.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // =====================================================
  // MODAL CREAR
  // =====================================================

  const openModal = () => {
    const modalEl = document.getElementById("createEntityModal");
    modalInstance = new bootstrap.Modal(modalEl);
    modalInstance.show();
  };

  const closeModal = () => {
    const modalEl = document.getElementById("createEntityModal");
    modalInstance = bootstrap.Modal.getInstance(modalEl);
    modalInstance.hide();

    setFormData({
      name: "",
      nit: ""
    });
  };

  // =====================================================
  // CREAR ENTIDAD
  // =====================================================

  const handleCreateEntity = async () => {

    if (!formData.name || !formData.nit) {
      alert("Todos los campos son obligatorios");
      return;
    }

    try {

      const response = await authFetch(ENDPOINTS.createEntity, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      if (response.success) {

        alert("Entidad creada correctamente");

        closeModal();

        const reload = await authFetch(ENDPOINTS.getEntity);

        if (reload.success) {
          setEntities(reload.entidades);
        }

      } else {
        alert(response.message);
      }

    } catch (error) {
      console.error(error);
      alert("Error al crear entidad");
    }

  };

  // =====================================================
  // CAMBIAR ESTADO
  // =====================================================

  const openStateModal = (entity) => {
    setSelectedEntity(entity);
    setShowModal(true);
  };

  const closeStateModal = () => {
    setSelectedEntity(null);
    setShowModal(false);
  };

  const handleConfirmToggle = async () => {

    if (!selectedEntity) return;

    try {

      const newState = Number(selectedEntity.state) === 1 ? 0 : 1;

      const res = await authFetch(
        `${ENDPOINTS.changeStateEntity}?id=${selectedEntity.id_entidad}`,
        {
          method: "PUT",
          body: JSON.stringify({ state: newState })
        }
      );

      if (res.success) {

        setEntities(prev =>
          prev.map(e =>
            e.id_entidad === selectedEntity.id_entidad
              ? { ...e, state: newState }
              : e
          )
        );

        alert("Estado actualizado");

      } else {
        alert(res.message);
      }

    } catch (error) {
      alert("Error con el servidor");
    }

    closeStateModal();
  };

  // =====================================================
  // RENDER
  // =====================================================

  if (loading) return <p>Cargando entidades...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Entidades</h2>

        <button className="btn btn-outline-pink" onClick={openModal}>
          <i className="bi bi-building"></i> Crear Entidad
        </button>
      </div>

      {/* FILTROS */}

      <div className="row mb-3">

        <div className="col-md-4">
          <label className="m-1">Buscar por nombre o NIT</label>

          <input
            type="text"
            className="form-control"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="col-md-3">
          <label className="m-1">Estado</label>

          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => setStateFilter(e.target.value)}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>

      </div>

      {/* TABLA */}

      {currentEntities.length > 0 ? (

        <>
          <table className="table table-hover">

            <thead className="table-secondary">
              <tr>
                <th>Nombre</th>
                <th>NIT</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>

              {currentEntities.map((entity) => (

                <tr key={entity.id_entidad}>

                  <td>{entity.name}</td>

                  <td>{entity.nit}</td>

                  <td>
                    {Number(entity.state) === 1
                      ? "Activo"
                      : "Inactivo"}
                  </td>

                  <td>

                    <button
                      className={`btn btn-sm ${
                        Number(entity.state) === 1
                          ? "btn-outline-pink"
                          : "btn-outline-purple"
                      }`}
                      onClick={() => openStateModal(entity)}
                    >
                      <i className="bi bi-power me-1"></i>
                      {Number(entity.state) === 1
                        ? "Desactivar"
                        : "Activar"}
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>

      ) : (

        <p>No hay entidades registradas.</p>

      )}

      {/* MODAL CAMBIAR ESTADO */}

      {showModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={closeStateModal}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Cambiar Estado</h5>
                  <button className="btn-close" onClick={closeStateModal}></button>
                </div>

                <div className="modal-body">
                  <p>
                    ¿Deseas cambiar el estado de la entidad{" "}
                    <b>{selectedEntity?.name}</b>?
                  </p>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeStateModal}>
                    Cancelar
                  </button>
                  <button
                    className="btn btn-outline-pink"
                    onClick={handleConfirmToggle}
                  >
                    Confirmar
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}

      {/* MODAL CREAR ENTIDAD */}

      <div
        className="modal fade"
        id="createEntityModal"
        tabIndex="-1"
        aria-hidden="true"
      >

        <div className="modal-dialog modal-dialog-centered">

          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Crear Entidad</h5>

              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
              ></button>

            </div>

            <div className="modal-body">

              <div className="mb-3">

                <label>Nombre de la entidad</label>

                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      name: e.target.value
                    }))
                  }
                />

              </div>

              <div className="mb-3">

                <label>NIT</label>

                <input
                  type="text"
                  className="form-control"
                  value={formData.nit}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      nit: e.target.value
                    }))
                  }
                />

              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancelar
              </button>

              <button
                className="btn btn-outline-pink"
                onClick={handleCreateEntity}
              >
                Crear
              </button>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Entity;